module.exports = __webpack_public_path__ + "img/info.60f38d62.svg";